// @flow

import type { UserState } from "./types";

export const initialState: UserState = {
  error: null,
  requestsInProgress: 0,
  overview: {
    notificationReviews: [],
    statistics: [],
    today: [],
    targetedReasons: null,
  },
};

export default initialState;
